const SERVER_DEV = process.env.REACT_APP_TARGET_SERVER_LOCAL;
const SERVER_PROD = process.env.REACT_APP_TARGET_SERVER_PRODUCTION;

const environment = {
  rootApi: process.env.NODE_ENV === "production" ? SERVER_PROD : SERVER_DEV
};

export default environment;
